import React from 'react'
import Nav from '../Nav/Nav'
import { useState,useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Link } from 'react-router-dom';
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';
import './agent.css'


const Agent = () => {
  /*
  to sell property we require ofllowing docs:
  Aadhar card.
  Passport-size of both seller and buyer.
  Verified copy of the original old sale deed.
  Copy of No objection certificate under the land ceiling Act.
  Copy of the latest property register card
  Copy of Municipal tax bill.
  Construction completion certificate
  Recorded agreement between the builder and original purchaser of the building initially.

  Payment of upto 500 if canclelling  And complete Application Form And submit with documents for verification in sub registrar office
  At last provided with acknow receipt
  */

  /*
  to buy a resale property document
  1. Title Verification
  2. NOC from Bank 3. Title Deed 4. Sale Deed
  5. Building Approval Certificate
  6. Completion/Occupancy Certificate
  7. Encumbrance Certificate
  8. Possession Certificate
  9.Conversion order
  Utility Bills, Latest Tax Paid Receipt, No Objection Certificate (NOC) from the competent authorities, No Dues Certificate from Society and Share Certificate.
  */
  const tableRef = useRef(null);

  /********SELLER TABLE DATA AND COLUMNS ***********/
  const columns = [ 
      { field: "id", headerName: "P_id", width: 100 },
      {field: "approve", headerName: "Approve/Reject",width: 270,
      renderCell: (params) => {
          return (<>
                <button  className="widgetLgButtonApproved">Approved</button>
                <button  className='widgetLgButtonDeclined'>Rejected</button>
                <button  className='widgetLgButtonPending'>Pending</button>
                </>);
        },
      }, 
      {field: "ack", headerName: "Acknowledgment receipt",width: 200,
      renderCell: (params) => {
          return (<>
                <button  className='WidgetLgButton'>View</button>
                </>);
        },
      },
      {field: "scan", headerName: "Scanned Docs",width: 200,
      renderCell: (params) => {
          return (<>
                <button  className='WidgetLgButton'>View</button>
                </>);
        },
      },      
      { field: "aadhar", headerName: "Aadhar card", width: 200 },
      { field: "photo",headerName: "Passport-size Photo",width: 200,},
      { field: "deed", headerName: "Old Sale Deed", width: 200 },
      { field: "noc", headerName: "NOC", width: 200 },
      { field: "register", headerName: "Property register card", width: 200 },
      { field: "tax", headerName: "Municipal tax bill", width: 200 },
      { field: "construct", headerName: "Construction completion certificate", width: 200 },
      { field: "recorded", headerName: "Recorded agreement", width: 200 },
      { field: "pay", headerName: "Payment", width: 200 },
      { field: "form", headerName: " Application Form", width: 200 },
        ];

  const data=[
    {id:"1", aadhar:"pending", photo:"accepted",deed:"accepted",  noc: "accepted", register: "pending", tax: "pending", construct: "pending", recorded: "pending", pay: "pending", form: "pending",},
    {id:"2", aadhar:"pending", photo:"accepted",deed:"accepted",  noc: "accepted", register: "pending", tax: "pending", construct: "pending", recorded: "pending", pay: "pending", form: "pending",},
    {id:"3", aadhar:"pending", photo:"accepted",deed:"accepted", noc: "accepted", register: "pending", tax: "pending", construct: "pending", recorded: "pending", pay: "pending", form: "pending",},
        ]
    

  /********BUYER TABLE DATA AND COLUMNS ***********/
  const columns2 = [ 
      { field: "id", headerName: "P_id", width: 100 },
      {field: "approved", headerName: "Approve/Reject",width: 270,
      renderCell: (params) => {
          return (<>
                <button  className="widgetLgButtonApproved">Approved</button>
                <button  className='widgetLgButtonDeclined'>Rejected</button>
                <button  className='widgetLgButtonPending'>Pending</button>
                </>);
        },
      }, 
      {field: "ack", headerName: "Payment Verification",width: 200,
      renderCell: (params) => {
          return (<>
                <button  className='WidgetLgButton'>View</button>
                </>);
        },
      },
      {field: "scan", headerName: "Scanned Docs",width: 200,
      renderCell: (params) => {
          return (<>
                <button  className='WidgetLgButton'>View</button>
                </>);
        },
      },      
      { field: "aadhar", headerName: "Aadhar card", width: 200 },
      { field: "bank", headerName: "Bank Details", width: 200 },
      { field: "photo",headerName: "Passport-size Photo",width: 200,},
      { field: "noc", headerName: "NOC", width: 200 },
        ];

  const data2=[
    {id:"1", aadhar:"pending", photo:"accepted",bank:"provided",deed:"accepted",  noc: "accepted"},
    {id:"2", aadhar:"pending", photo:"accepted",bank:"provided",deed:"accepted",  noc: "accepted"},
    {id:"3", aadhar:"pending", photo:"accepted",bank:"provided",deed:"accepted", noc: "accepted" },
        ]
        

  /********ESCROW CONTRACT TABLE DATA AND COLUMNS ***********/
  const columns3 = [ 
    { field: "id", headerName: "P_id", width: 100 },
    {field: "scan", headerName: "Approve/Reject",width: 270,
    renderCell: (params) => {
        return (<>
              <button  className="widgetLgButtonApproved">Approved</button>
              <button  className='widgetLgButtonDeclined'>Rejected</button>
              <button  className='widgetLgButtonPending'>Pending</button>
              </>);
      },
    },      
    {field: "ack", headerName: "View Contract",width: 200,
    renderCell: (params) => {
        return (<>
              <button  className='WidgetLgButton'>View</button>
              </>);
      },
    },
    
    { field: "buyerS", headerName: "Buyer Status", width: 200 },
    { field: "sellerS",headerName: "Seller Status",width: 200,},
    { field: "grievance",headerName: "Grievances",width: 170,},
    { field: "payB", headerName: "Payment by Buyer", width: 250 },
    { field: "sellD",headerName: "Seller Documents ",width: 220,},
    { field: "payS", headerName: "Payment to Seller", width: 250 },
    { field: "docB",headerName: "Document Delivery to Buyer",width: 300,},
    { field: "status",headerName: "Escrow status",width: 200,},
      ];

  const data3=[
        {id:"1",buyerS:"pending",sellerS:"pending","grievance":"None","payB":"recieved","sellD":"recieved","payS":"granted","docB":"done","status":"complete"},
        {id:"2", buyerS:"verified", sellerS:"verified","grievance":"None", "payB":"recieved","sellD":"recieved","payS":"granted","docB":"done","status":"complete"},
        {id:"3", buyerS:"pending", sellerS:"verified","grievance":"None","payB":"recieved","sellD":"recieved","payS":"granted","docB":"done","status":"complete"},
            ]
        
  return (
    <div>
        <Nav/>
        <div className="Agent">
            <div className="AgentTable1">
              <div className="orderTitle"><GridViewRoundedIcon />Verify Escrow Contract</div>
              <div style={{"height":"50vh"}}>
              <DataGrid
                  rows={data3}
                  disableSelectionOnClick
                  columns={columns3}
                  pageSize={8}
                  checkboxSelection
                  ref={tableRef}
              />
              <br/>
              </div>
            </div> 

           <div className="AgentTable1">
              <div className="orderTitle"><GridViewRoundedIcon />Verify sellers</div>
              <div style={{"height":"50vh"}}>
              <DataGrid
                  rows={data}
                  disableSelectionOnClick
                  columns={columns}
                  pageSize={8}
                  checkboxSelection
                  ref={tableRef}
              />
              <br/>
              </div>
            </div> 

           <div className="AgentTable1">
              <div className="orderTitle"><GridViewRoundedIcon />Verify Buyers</div>
              <div style={{"height":"50vh"}}>
              <DataGrid
                  rows={data2}
                  disableSelectionOnClick
                  columns={columns2}
                  pageSize={8}
                  checkboxSelection
                  ref={tableRef}
              />
              <br/>
              </div>
            </div> 

        </div>
    </div>
  )
}

export default Agent